import React from 'react'
import styled from 'styled-components'
import NumberFormat from 'react-number-format';

// components
import Grid from '@material-ui/core/Grid'
import ColoredLabel from 'components/ColoredLabel'
import { TextInput as CTextInput, Select } from 'components/StyledComponents'

const ErrorMessage = styled.div`
  font-size: 12px;
  color: red;
  margin-left: 5px;
`;

const LabelWrapper = styled(Grid)`
  @media only screen and (max-width: 450px) {
    margin-bottom: 5px !important;
  }
`;

const TextInput = styled(CTextInput)`
  margin: 0;
`

const FormItem = ({
  title, 
  placeholder, 
  background, 
  type = 'text', 
  select = false, 
  options = [],
  errorMsg,
  name = null,
  thousandSeparator = false,
  tooltip = '',
  onChange,
  value
}) => (
  <Grid container style={{marginBottom: 10}} wrap="wrap" alignItems="center">
    <LabelWrapper item xs={6} sm={4} style={{paddingRight: 10}}>
      <ColoredLabel title={title} background={background} tooltip={tooltip} />
    </LabelWrapper>
    <Grid item xs={12} sm={8}>
      {
        !select ?
        <NumberFormat
          customInput={TextInput}
          placeholder={placeholder}
          value={value}
          fullWidth
          thousandSeparator={true}
          decimalScale={2}
          onValueChange={(target) => {
            onChange(target.floatValue);
          }}
          isNumericString
        /> :
        <Select
          style={{margin: 0}}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
        >
          {
            options.map((item, i) => (
              <option key={i} value={item.value}>{item.name}</option>
            ))
          }
        </Select>
      }
    </Grid>
    {
      errorMsg && <ErrorMessage>{errorMsg}</ErrorMessage>
    }
  </Grid>
)

export default FormItem;
